module.exports = __webpack_public_path__ + "img/ring_g_e_null_1@3x.5dbe1bc6.png";